import React, { useState, useEffect } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Video from 'yet-another-react-lightbox/plugins/video';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

export default function ImageViewer({ images = [], index, setIndex }) {
    const [isOpen, setIsOpen] = useState(false);
    const [slides, setSlides] = useState([]);

    useEffect(() => {
        const formattedSlides = images.map(image => {
            if (image.src.includes('youtube.com') || image.src.includes('vimeo.com')) {
                return {
                    type: 'video',
                    sources: [{
                        src: image.src,
                        type: 'video/youtube',
                    }],
                };
            }
            return { src: image.src };
        });
        setSlides(formattedSlides);

        if (index >= 0) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [images, index]);

    const handleClose = () => setIndex(-1);

    return (
        <div aria-hidden="true">
            <Lightbox
                open={isOpen}
                close={handleClose}
                slides={slides}
                noScroll={true}
                index={index >= 0 ? index : 0}
                on={{
                    view: ({ index: currentIndex }) => setIndex(currentIndex)
                }}
                plugins={[Video,Zoom]}
            />
        </div>
    );
}

